export const WINDOW_PROP_KEY_TIMESTAMP_APP_HTML_PARSED = "__timestamp_app_html_parsed";

export const TextModePageScript = `
  window["${WINDOW_PROP_KEY_TIMESTAMP_APP_HTML_PARSED}"] = Date.now();
`;

